import {Survey} from 'core/SurveyModels'

export interface SurveyPageProcessorMeta {
  pageIndex: number
}

export interface SurveyPageProcessorResponse {
  survey: Survey
  canProceed: boolean
}

export abstract class SurveyPageProcessor {
  constructor(
    protected survey: Survey,
    protected meta: SurveyPageProcessorMeta
  ) {}

  abstract process(): Promise<SurveyPageProcessorResponse>

  static instance = function (
    _: Survey,
    __: SurveyPageProcessorMeta
  ): SurveyPageProcessor {
    throw new Error('Survey: Page Processor missing static instance method')
  }
}
